import SettingsSVG from "@design-system/ui-icons/vanilla/Settings"
import { createIcon } from "../createIcon"

export const SettingsIcon = createIcon(SettingsSVG)
